import { ACITONCOPYRIGHT } from '../../../actionTypes';

export function getListBySectionId(payload, callback, errorCallback) {
	return {
		type: ACITONCOPYRIGHT.COPYRIGHT_LIST_BY_SECTIONID,
		payload,
		callback,
		errorCallback
	};
}
